export default __webpack_public_path__ + "static/media/bag-full.3c6fa7a9.svg";